import { Inject, Injectable } from '@angular/core';
import { Observable, tap, shareReplay, catchError, throwError } from 'rxjs';
import { ConfigEntity } from '@repository/config/entities/config.entity';
import { Env, ENV } from '@providers/env.provider';
import { EnvironmentRepositoryService } from '@repository/config/environment.repository.service';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private init$?: Observable<ConfigEntity>;

  public constructor(
    private configRepository: EnvironmentRepositoryService,
    @Inject(ENV) private env: Env,
  ) {}

  public init(): Observable<ConfigEntity> {
    if (!this.init$) {
      this.init$ = this.configRepository.getConfigEntity().pipe(
        tap((config) => this.env.set(config)),
        catchError((err) => {
          // allow retry if init fails
          this.init$ = undefined;
          return throwError(() => err);
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }
    return this.init$;
  }
}
